import { Appointment } from '../services/appointmentService';
import { AppointmentType } from '../services/appointmentTypeService';

/**
 * Darken a hex color by a given percentage.
 */
export const darkenColor = (color: string, percent: number): string => {
    let col = color.startsWith('#') ? color.slice(1) : color;

    if (col.length === 3) {
        col = col.split('').map(char => char + char).join('');
    }

    let num = parseInt(col, 16);
    if (isNaN(num)) {
        console.warn(`Invalid color format for darkenColor: ${color}`);
        return color;
    }
    let r = (num >> 16);
    let g = (num >> 8 & 0x00FF);
    let b = (num & 0x0000FF);

    let factor = 1 - percent / 100;
    r = Math.max(0, Math.min(255, Math.floor(r * factor)));
    g = Math.max(0, Math.min(255, Math.floor(g * factor)));
    b = Math.max(0, Math.min(255, Math.floor(b * factor)));

    let darkColor = `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
    return darkColor;
};

/**
 * Get the background color for an appointment based on its type.
 */
export const getAppointmentColor = (appointment: Appointment, appointmentTypes: AppointmentType[]): string => {
    const appointmentType = appointmentTypes.find(type => type.id === appointment.appointmentTypeId);
    return appointmentType?.color || '#1976d2';
};

/**
 * Get the text color for an appointment based on its type.
 */
export const getAppointmentTextColor = (appointment: Appointment, appointmentTypes: AppointmentType[]): string => {
    const appointmentType = appointmentTypes.find(type => type.id === appointment.appointmentTypeId);
    return appointmentType?.textColor || '#ffffff';
};
